// WHAT I HAVE TO PRODUCE TODAY — the dated tasks whose day has arrived.
//
// THE ROWS ARE THE BELL'S OWN. They come from `alerts.tasks.rows` (calculations/dueTasks
// through AlertsContext), already judged, already oldest-first. Nothing here decides
// whether a date has arrived — the browser only chooses which heading a row sits under
// and which colour it wears.
//
// SPLIT INTO באיחור AND להיום, which is the one thing this page does that the bell does
// not. The bell is a list of what is asking for attention and one order serves it; a day
// page is a PLAN FOR TODAY, and a task carried over from last week must not be read as
// something scheduled for today. Same rows, same order within each group, two headings.
import he from '../../i18n/he';
import UrgencyBadge from '../../components/UrgencyBadge';
import { boardLink, boardLinkLabel } from '../../utils/boardLink';
import { taskClient } from '../../utils/taskClient';
import DayRow from './DayRow';
import { DayGroup } from './DaySection';

const TaskRow = ({ row }) => (
  <DayRow
    to={boardLink(row)}
    late={row.due_state === 'overdue'}
    color={taskClient(row.client).color}
    name={taskClient(row.client).name}
    date={row.due_date}
    go={boardLinkLabel(row)}
    foot={(
      <>
        {/* The orphan marker, carried over from the bell because this page reads the
            same rows: a task on a lost lead or a deactivated client is on no list, and
            a row whose link goes to a client card needs to say why. */}
        {row.board === 'none'
          ? <span className="day-orphan" title={he.myDay.noBoardHint}>{he.myDay.noBoard}</span>
          : <span className="muted">{row.assigned_partner_name || ''}</span>}
        <UrgencyBadge value={row.urgency} />
      </>
    )}
  >
    {/* The note is what the task was scheduled WITH — the thing actually needed when the
        day arrives. The title is the fallback, not the headline. Opaque: shown, never
        read. */}
    <span className="day-row-text">{row.note || row.title}</span>
  </DayRow>
);

export default function DayTasks({ rows }) {
  // Only two states can reach here: `dueTasks.list` sends nothing whose date has not
  // arrived, so anything not overdue is today's.
  const late = rows.filter((r) => r.due_state === 'overdue');
  const today = rows.filter((r) => r.due_state !== 'overdue');

  return (
    <div className="day-groups">
      {late.length > 0 && (
        <DayGroup title={he.myDay.groupLate} late>
          {late.map((row) => <TaskRow key={row.id} row={row} />)}
        </DayGroup>
      )}
      {today.length > 0 && (
        <DayGroup title={he.myDay.groupToday}>
          {today.map((row) => <TaskRow key={row.id} row={row} />)}
        </DayGroup>
      )}
    </div>
  );
}
